import React, { useState, useEffect } from "react";
import { Modal, Form } from "react-bootstrap";
import CommonButton from "../../commonButton";
import withModal from "../../withModal";
import { useToast } from "../../../context/TostContext";
import InputField from "../../form/InputField";

const WorkRegionModal = ({ onClose, onSubmit, region, isLoading }) => {
  const [title, setTitle] = useState("");
  const toast=useToast();
  useEffect(() => {
    if (region) {
      setTitle(region.title || "");
    } else {
      setTitle("");
    }
  }, [region]);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!title.trim()) {
      toast.error("Please enter a title");
      return;
    }

    const data = {
      title
    };

    onSubmit(data);
  };

  return (
    <Form onSubmit={handleSubmit} noValidate>
      <Modal.Body>
        <InputField
          label={{ name: "Title" }}
          required
          input={{
            type: "text",
            placeholder: "e.g. North America, Remote, Europe",
            value: title,
            onChange: (e) => setTitle(e.target.value),
          }}
        />
      </Modal.Body>
      <Modal.Footer>
        <CommonButton 
          title="Cancel" 
          type="button" 
          variant="outline"
          onClick={onClose} 
        />
        <CommonButton 
          title={region ? "Save Changes" : "Add Region"} 
          type="submit" 
          variant="primary"
          isLoading={isLoading} 
        />
      </Modal.Footer>
    </Form>
  );
};

export default withModal(WorkRegionModal);
